import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Cell } from '../../base/styled';
import { NumberWidget, BarChartWidget } from '../../widgets';

const PrimeTimeDevices = (props) => {

  const {
    results: {
      error = null,
      data: {
        labels: {
          title = '',
          subtitle = '',
        } = {},
        peak = null,
        devices = null,
      } = {},
    } = {},
  } = props;

  /*
  const pdf_peak = {
    ...peak,
    className: 'pdf',
  };

  const pdf_devices = {
    ...devices,
    className: 'pdf',
  };
   */

  return (
    <div className="dashboard">
      <Grid columns={2} rows="200px 1fr" height="inherit" justifyContent="space-around">
        <Cell>
          <div style={{ marginBottom: '80px' }}>
            <h1>{title}</h1>
            <h2>{subtitle}</h2>
          </div>
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: peak }} />
        </Cell>
        <Cell width={2}>
          <BarChartWidget input={{ error, data: devices }} />
        </Cell>
      </Grid>
    </div>
  );
};

PrimeTimeDevices.defaultProps = null;

PrimeTimeDevices.propTypes = {
  results: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      labels: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
      }),
      peak: NumberWidget.dataPropType,
      devices: BarChartWidget.dataPropType,
    }),
  }),
};

export default PrimeTimeDevices;
